import { Component } from "react";

/**
 * Captura errores de render/efecto de cualquier componente hijo para que un fallo
 * puntual NO deje toda la aplicación en blanco. Muestra un aviso recuperable con el
 * mensaje del error (útil para diagnóstico) y un botón para recargar la vista.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    // Log explícito para poder recuperar el error real (no solo el stack minificado).
    console.error("[ErrorBoundary] Error de render capturado:", error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ error: null, info: null });
  };

  render() {
    const { error, info } = this.state;
    if (!error) return this.props.children;

    return (
      <div
        style={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          fontFamily: "system-ui, sans-serif",
        }}
      >
        <div
          style={{
            maxWidth: 560,
            width: "100%",
            background: "#fff",
            border: "1px solid #fecaca",
            borderRadius: 14,
            boxShadow: "0 12px 40px rgba(15,23,42,0.12)",
            padding: 24,
          }}
        >
          <div style={{ fontSize: 18, fontWeight: 800, color: "#b91c1c", marginBottom: 8 }}>
            Se ha producido un error en la pantalla
          </div>
          <p style={{ fontSize: 13, color: "#475569", lineHeight: 1.5, margin: "0 0 14px" }}>
            La vista no pudo dibujarse correctamente, pero la sesión sigue activa. Puedes intentar
            recuperar la vista o recargar la página.
          </p>
          <div
            style={{
              background: "#0f172a",
              color: "#fca5a5",
              borderRadius: 8,
              padding: "10px 12px",
              fontSize: 12,
              fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              maxHeight: 180,
              overflow: "auto",
              marginBottom: 16,
            }}
          >
            {String(error?.message || error)}
            {info?.componentStack ? `\n${info.componentStack}` : ""}
          </div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <button
              type="button"
              onClick={this.handleReset}
              style={{
                padding: "9px 16px",
                borderRadius: 8,
                border: "1px solid #cbd5e1",
                background: "#fff",
                color: "#0f172a",
                fontSize: 13,
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              Reintentar
            </button>
            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{
                padding: "9px 16px",
                borderRadius: 8,
                border: "none",
                background: "#2563eb",
                color: "#fff",
                fontSize: 13,
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              Recargar página
            </button>
          </div>
        </div>
      </div>
    );
  }
}
